import { Component } from "react";

import { PopupHoverContainer } from "@similarweb/ui-components";

import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import { noDataFilter } from "app/filters/ngFilters";
import type { HookType } from "app/services/ModalService";

import { UpgradeLink } from "./UpgradeLink";

export interface IDefaultCellProps {
    value: string | number;
    format?: string;
    dangerouslySetInnerHTML?: boolean;
    className?: string;
    hookType?: HookType;
    cellPopoverContent?: (row: FixmeType) => any;
    cellPopupConfig?: any;
    row?: any;
}

/**
 * @deprecated Use TextCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/core/TextCell/TextCell.tsx}
 */
export class DefaultCell extends Component<IDefaultCellProps> {
    private dynamicFilter: any;

    private noData: any;

    constructor(props: IDefaultCellProps) {
        super(props);
        this.dynamicFilter = dynamicFilterFilter();
        this.noData = noDataFilter();
    }

    public render() {
        let { value } = this.props;
        const {
            format,
            dangerouslySetInnerHTML,
            className = "",
            cellPopoverContent,
            cellPopupConfig = { placement: "top" },
            row,
        } = this.props;
        if (format) {
            value = this.dynamicFilter(value, format);
        }
        value = this.noData(value, "^\\s*n\\/a\\s*$", "-");
        if (cellPopoverContent) {
            return (
                <PopupHoverContainer
                    content={() => cellPopoverContent(row)}
                    config={cellPopupConfig}
                >
                    <div className={`cell-innerText ${className}`}>{value}</div>
                </PopupHoverContainer>
            );
        }
        if (value !== "grid.upgrade") {
            return dangerouslySetInnerHTML ? (
                <div
                    className={`cell-innerText ${className}`}
                    dangerouslySetInnerHTML={{ __html: value?.toString() }}
                />
            ) : (
                <div className={`cell-innerText ${className}`}>{value}</div>
            );
        } else {
            return <UpgradeLink hookType={this.props.hookType} />;
        }
    }
}
